const state = () => ({
  initialData: [],
  headerData: {},
  currentHeaderData: []
})

const mutations = {
  set(state, { type, payload }) {
    state[type] = payload
  },

  mergeHeaderData(state, { path, payload }) {
    const { headerData, initialData } = state
    const merge = (...arrays) => {
      const result = []

      for (const arr of arrays) {
        if (Array.isArray(arr)) {
          for (const el of arr) {
            const existingObj = result.find(item => item.type === el.type)

            if (existingObj) {
              Object.assign(existingObj, el)
            } else {
              result.push({ ...el })
            }
          }
        }
      }

      return result
    }

    headerData[path] = merge(initialData, payload)
  },

  setCurrentHeaderData(state, path) {
    state.currentHeaderData = state.headerData[path]
  }
}

const actions = {
  async fetchHeaderData({ rootState, state, commit }, { path, types, forced = false }) {
    try {
      const { initialData, headerData } = state

      if (!headerData[path] || forced) {
        const { jwtToken } = rootState.user
        const Authorization = jwtToken ? `Bearer ${jwtToken}` : null

        const { data = [] } =
          await this.$repositories.navigation.getMenuListByType(
            'main',
            Authorization,
            path,
            ...types
          )

        if (!initialData.length || forced) {
          await commit('set', {
            type: 'initialData',
            payload: data
          })
        }

        await commit('mergeHeaderData', {
          path,
          payload: data
        })
      }

      await commit('setCurrentHeaderData', path)
    } catch (e) {}
  }
}

export default {
  state,
  actions,
  mutations
}
